import type { CotizaTodasResponse } from '@/types/quote.types';
import type { ResultsCompany } from '@/components/widget/results/results-view.types';

export interface QuoteCandidates {
  qualitas: CotizaTodasResponse | null;
  ana: CotizaTodasResponse | null;
  chubb: CotizaTodasResponse | null;
}

const hasCobertura = (quote: CotizaTodasResponse | null): boolean => Boolean(quote?.Cobertura);

const candidateFor = (company: ResultsCompany, quotes: QuoteCandidates): CotizaTodasResponse | null => {
  if (company === 'CHUBB') return quotes.chubb;
  if (company === 'ANA') return quotes.ana;
  return quotes.qualitas;
};

export function pickSelectedQuotes(selected: ResultsCompany, quotes: QuoteCandidates): CotizaTodasResponse | null {
  const preferred = candidateFor(selected, quotes);
  if (preferred && hasCobertura(preferred)) return preferred;
  if (hasCobertura(quotes.qualitas)) return quotes.qualitas;
  return quotes.ana || quotes.chubb || null;
}

export function pickSummaryCompany(selected: ResultsCompany, quotes: QuoteCandidates): ResultsCompany {
  if (hasCobertura(candidateFor(selected, quotes))) return selected;
  if (hasCobertura(quotes.qualitas)) return 'QUALITAS';
  if (hasCobertura(quotes.ana)) return 'ANA';
  return 'CHUBB';
}

export function pickQuotesForEmission(selected: ResultsCompany, quotes: QuoteCandidates): CotizaTodasResponse | null {
  if (selected === 'CHUBB') return null;
  const preferred = selected === 'ANA' ? quotes.ana : quotes.qualitas;
  if (preferred && hasCobertura(preferred)) return preferred;
  return quotes.qualitas || quotes.ana || null;
}
